import React from 'react'
import { BlankViewImageVariants, BlankView } from 'src/Components/blank-view'
import { useNavigate } from 'react-router-dom'

interface Props {
  titleKey?: string
  explanationKey?: string
}

/**
 * Displays a blank in case of an offline installation to explain to the user why no data is visible.
 */
const OfflineInstallationBlankView: React.FC<Props> = ({
  titleKey = 'installation.offline-mode.blank-view.title',
  explanationKey = 'installation.offline-mode.blank-view.explanation',
}) => {
  const navigate = useNavigate()
  return (
    <BlankView
      imageVariant={BlankViewImageVariants.Worried}
      title={titleKey}
      explanation={explanationKey}
      action={{
        text: 'common.back',
        onClick: () => navigate(-1),
      }}
    />
  )
}

export default OfflineInstallationBlankView
